import { apiCreate } from '@/actions/ApiBaseActions';
// 問い合わせ
export const API_CREATE_CONTACT = 'API_CREATE_CONTACT';
export const apiCreateContact = ({ json }, meta) => apiCreate(API_CREATE_CONTACT, '/contact', json, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
// コンサル選定のお問い合わせ
export const API_CREATE_CONTACT_CONSULTATION_GUEST = 'API_CREATE_CONTACT_CONSULTATION_GUEST';
export const apiCreateContactConsultationGuest = ({ json }, meta) => apiCreate(API_CREATE_CONTACT_CONSULTATION_GUEST, '/consultation', json, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
